import React from 'react'
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import CountUp from 'react-countup'

// external module classnames that let you apply more than one style.
import cx from 'classnames';


import styles from './Cards.module.css'

function Cards({ data: { confirmed, recovered, deaths, lastUpdate }}) {
    if (!confirmed) {
        return 'Loading...';
    }
    
    return (
        <div className={styles.container}>
            <Grid container spacing={3} justify="center">
                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.infected)}>
                    <CardContent >
                        <Typography color="textSecondary" gutterBottom> Infected </Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={confirmed.value} duration={2.5} separator="," />
                        </Typography>
                        <Typography color="textSecondary">{new Date(lastUpdate).toString()}</Typography>
                        <Typography variant="body2">Number of active cases of COVID-19</Typography>
                    </CardContent>
                </Grid>



                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.recovered)}>
                    <CardContent >
                        <Typography color="textSecondary" gutterBottom> Recovered </Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={recovered.value} duration={2.5} separator="," />
                        </Typography>
                        <Typography color="textSecondary">{new Date(lastUpdate).toString()}</Typography>
                        <Typography variant="body2">Number of recovaries from COVID-19</Typography>
                    </CardContent>
                </Grid>



                <Grid item component={Card} xs={12} md={3} className={cx(styles.card, styles.deaths)}>
                    <CardContent >
                        <Typography color="textSecondary" gutterBottom> Death </Typography>
                        <Typography variant="h5">
                            <CountUp start={0} end={deaths.value} duration={2.5} separator="," />
                        </Typography>
                        <Typography color="textSecondary">{new Date(lastUpdate).toString()}</Typography>
                        <Typography variant="body2">Number of death caused by COVID-19</Typography>
                    </CardContent>
                </Grid>
            </Grid>
        </div>
    )
}

export default Cards
